/**
 * Service for ingestion operations using the generated SDK
 */
import {
  searchIngestionsControllerExport
} from '../generated/api';
import { eduleadClient } from './edulead-client';

class IngestionsService {

  /**
   * Export ingestions in various formats
   */
  async exportIngestions(request: any): Promise<any> {
    try {
      return searchIngestionsControllerExport({
        body: request,
        client: eduleadClient
      });
    } catch (error) {
      console.error('Failed to export ingestions:', error);
      throw new Error('Failed to export ingestions');
    }
  }
}

export const ingestionsApi = new IngestionsService();